import { transformObjectKeys } from "@core/utility/common-utils"
import { RecursiveSnakeCaseType, transformFromCamelCaseToSnakeCase, transformFromSnakeCaseToCamelCase } from "@core/utility/string-utils"
import { Observable, of, take } from "rxjs"

export let updateUserLoad = (uiBody:UpdateUserUIRequestBody): Observable<UpdateUserAPIRequestBody>=>{


  let apiBody = new UpdateUserAPIRequestBody({data:transformObjectKeys(
    uiBody,
    transformFromCamelCaseToSnakeCase
  )})

  return of(apiBody)
  .pipe(
    take(1),
  )
}

export let updateUserSuccess = (apiBody:UpdateUserAPIResponseBody):UpdateUserUIResponseBody=>{
  let uiBody = new UpdateUserUIResponseBody(transformObjectKeys(
    apiBody.data,
    transformFromSnakeCaseToCamelCase
  ))
  return uiBody
}

export class UpdateUserUIRequestBody {
  constructor(props:Partial<UpdateUserUIRequestBody>={}){
    let origProps = Object.entries(props).filter(([key, val]) => {
      return !key.startsWith('prop');
    });
    Object.assign(this, { ...Object.fromEntries(origProps) });
  }
  accessToken:string
  users:Array<Partial<{
    photoUrl:{
      content:string,
      mimeType:string
    }
    displayName:string
    email:string
    emailVerified:boolean
    phoneNumber:string
    emailMarketingConsent:boolean
    smsMarketingConsent:boolean
    incomingVideosNotifications:boolean
    startWithGuide:boolean
  }>>
}

export class UpdateUserAPIRequestBody {
  constructor(props:Partial<UpdateUserAPIRequestBody>={}){
    let origProps = Object.entries(props).filter(([key, val]) => {
      return !key.startsWith('prop');
    });
    Object.assign(this, { ...Object.fromEntries(origProps) });
  }
  data:RecursiveSnakeCaseType<UpdateUserUIRequestBody&{photoUrl:string}>
}

export class UpdateUserUIResponseBody {
  constructor(props:Partial<UpdateUserUIResponseBody>={}){
    let origProps = Object.entries(props).filter(([key, val]) => {
      return !key.startsWith('prop');
    });
    Object.assign(this, { ...Object.fromEntries(origProps) });
  }

}

export class UpdateUserAPIResponseBody {
  constructor(props:Partial<UpdateUserAPIResponseBody>={}){
    let origProps = Object.entries(props).filter(([key, val]) => {
      return !key.startsWith('prop');
    });
    Object.assign(this, { ...Object.fromEntries(origProps) });
  }
  data:RecursiveSnakeCaseType<UpdateUserUIResponseBody>
}

